export default {
  setKeywords(state, payload) {
    state.keyword = payload; // Vuex state'i güncelle
  },
  setBannedWords(state, payload) {
    state.bannedWord = payload;
  },
  setTagTypes(state, payload) {
    state.keywordTagTypes = payload; // Vuex state'i güncelle
  },
  setKeywordTag(state, payload) {
    const tagType = state.keywordTagTypes.find((x) => x.id == payload.tagType);
    const keywordTag = {
        id: payload.id,
        text: payload.tag,
        type: tagType ? tagType.text : "Unknown",
    };
    state.keywordTags = [...state.keywordTags, keywordTag]; // Reaktif güncelleme
  },

  setKeywordTags(state, payload) {
    if (Array.isArray(payload)) {
      state.keywordTags = [...payload];
    } else {
      state.keywordTags = [];
      // İsterseniz burada bir uyarı/log ekleyebilirsiniz
    }
  },
  setKeywordVariations(state, payload) {
    
    state.variationVal = payload.variations;
  },

  setKeywordDetail(state, payload) {
    state.KeywordDetail = payload;
    state.variationVal = payload.variations;
    state.sourceVal = payload.sources;
    state.langCode = payload.LangCode; // LangCode'u state'e ekle
  },
  deleteKeywordTag(state, payload) {
    const toBeRemovedTag = state.keywordTags.find((x) => x.id == payload.id);
    const indexToBeRemoved = state.keywordTags.indexOf(toBeRemovedTag);

    state.keywordTags.splice(indexToBeRemoved, 1);
  },

  setActiveSource(state, payload) {
    state.sourceOptions = payload;
}
};
